var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3335 9.18081L12.4999 15.3333L6.66683 9.18081L7.53989 8.33325L12.4999 13.5639L17.4608 8.33325L18.3335 9.18081Z",
    fill: "#858F9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListExpand);
export default __webpack_public_path__ + "static/media/list_expand.68c09deb54df12ebcde2fe181506f416.svg";
export { ForwardRef as ReactComponent };